import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-187">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-188">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-189" />

          {/* Modal content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="relative bg-brand-gray border border-white/10 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden z-10" data-id="element-190">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-191">
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide text-white" data-id="element-192">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 transition-colors cursor-pointer" aria-label="Cerrar" data-id="element-193">
                <XIcon size={24} className="text-gray-400" data-id="element-194" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-300 font-inter text-sm leading-relaxed space-y-4" data-id="element-195">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}